import { Accessor, createContext, useContext } from 'solid-js';
import {
  SortableKeyOf,
  SortDirection,
  TreeNodeDefinition,
} from '@trimble/ui-components/solidjs';
import { ProjectDataFilterMode } from '../project-data.types';
import { ProjectDataSelection } from './project-data-panel-selection-factory';

export type SortByKey = SortableKeyOf<Pick<TreeNodeDefinition, 'id' | 'label'>>;

export interface ProjectDataPanelContextValue {
  filterText: Accessor<string>;
  sortBy: Accessor<SortByKey>;
  sortDirection: Accessor<SortDirection>;
  filterMode: Accessor<ProjectDataFilterMode>;
  panelScrollElement?: Accessor<HTMLElement | undefined>;
  /**
   * Provides panel-wide multi-selection support across all trees to facilitate bulk show/hide
   */
  selection?: ProjectDataSelection;
}

export interface ProjectDataPanelContextStore {
  filterText: Accessor<string>;
  sortBy: Accessor<SortByKey>;
  sortDirection: Accessor<SortDirection>;
  filterMode: Accessor<ProjectDataFilterMode>;
  panelScrollElement?: Accessor<HTMLElement | undefined>;
  selection: Accessor<ProjectDataSelection>;
}

const ProjectDataPanelContext = createContext<ProjectDataPanelContextStore>();

export function useProjectDataPanel(): ProjectDataPanelContextValue {
  const ctx = useContext(ProjectDataPanelContext);
  if (!ctx) {
    throw new Error(
      'useProjectDataPanel must be used within a ProjectDataPanel'
    );
  }
  return {
    filterText: ctx.filterText,
    sortBy: ctx.sortBy,
    sortDirection: ctx.sortDirection,
    filterMode: ctx.filterMode,
    panelScrollElement: ctx.panelScrollElement,
    selection: ctx.selection(),
  };
}

export { ProjectDataPanelContext };
